import $ from "jquery";

export default function initImageSlider() {
  // Initialize the image slider
  $(".js-image-slider").slick({
    dots: true,
    arrows: true,
    prevArrow:
      '<button class="button_arrow--left"><svg width="29" height="50" viewBox="0 0 29 50" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M26.3325 47.3916L3.78442 24.8435L26.3325 2.29541" stroke="black" stroke-width="5"/></svg></button>',
    nextArrow:
      '<button class="button_arrow--right"><svg width="29" height="50" viewBox="0 0 29 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.42578 2.2959L24.9739 24.844L2.42578 47.3921" stroke="black" stroke-width="5"/></svg></button>',
    focusOnSelect: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
}
